import React from 'react';
import StatsCard from './StatsCard';

interface DashboardStatsProps {
    dashboardData?: {
        positionsRecommendedPushed: number;
        applied: number;
        processOngoing: number;
        processClosed: number;
        opportunities: {
            assignment: number;
            onlineTest: number;
            interview: number;
        };
        rejected: Array<{
            companyId: string;
            companyName: string;
            rejectedCount: number;
            positions: Array<{
                positionId: string;
                positionName: string;
                feedback?: string;
            }>;
        }>;
    };
}

const DashboardStats: React.FC<DashboardStatsProps> = ({ dashboardData }) => {
    const statsData = dashboardData || {
        positionsRecommendedPushed: 0,
        applied: 0,
        processOngoing: 0,
        processClosed: 0,
        opportunities: {
            assignment: 0,
            onlineTest: 0,
            interview: 0,
        },
    };

    return (
        <div className="w-full">
            <h2 className="text-xl font-inter font-semibold dark:text-white text-[#28293D] mb-4">Overview</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-6">
                <StatsCard
                    title="Matched"
                    value={statsData.positionsRecommendedPushed}
                    className="bg-white dark:bg-[#1F2A37] border border-[#d1d5db] dark:border-[#555770]"
                />
                <StatsCard
                    title="Applied"
                    value={statsData.applied}
                    className="bg-white dark:bg-[#1F2A37] border border-[#d1d5db] dark:border-[#555770]"
                />
                <StatsCard
                    title="Process Ongoing (Live)"
                    value={statsData.processOngoing}
                    className="bg-white dark:bg-[#1F2A37] border border-[#d1d5db] dark:border-[#555770]"
                />
                <StatsCard
                    title="Process Closed"
                    value={statsData.processClosed}
                    className="bg-white dark:bg-[#1F2A37] border border-[#d1d5db] dark:border-[#555770]"
                />
            </div>

            {/* Opportunities Section */}
            <div className="mt-6">
                <h2 className="text-xl font-inter font-semibold dark:text-white text-[#28293D] mb-4">Opportunities</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <StatsCard
                        title="Assignment"
                        value={statsData.opportunities.assignment}
                        className="bg-white dark:bg-[#1F2A37] border border-[#d1d5db] dark:border-[#555770]"
                    />
                    <StatsCard
                        title="Online Test"
                        value={statsData.opportunities.onlineTest}
                        className="bg-white dark:bg-[#1F2A37] border border-[#d1d5db] dark:border-[#555770]"
                    />
                    <StatsCard
                        title="Interview"
                        value={statsData.opportunities.interview}
                        className="bg-white dark:bg-[#1F2A37] border border-[#d1d5db] dark:border-[#555770]"
                    />
                </div>
            </div>
        </div>
    );
};

export default DashboardStats;

